import { OnInit, EventEmitter } from '@angular/core';
import { Question } from "../../shared/models/question";
var QuestionComponent = /** @class */ (function () {
    function QuestionComponent() {
        this.LABEL_SIZE = 6;
        this.question_class_size = 6;
        this.answered = new EventEmitter();
    }
    QuestionComponent.prototype.ngOnInit = function () {
        this.calculateColumnSizes();
    };
    Object.defineProperty(QuestionComponent.prototype, "horizontal", {
        get: function () {
            return !this.vertical;
        },
        enumerable: true,
        configurable: true
    });
    QuestionComponent.prototype.getLabelClasses = function () {
        if (this.labels.length < this.LABEL_SIZE) {
            var colSize = this.LABEL_SIZE - this.labels.length;
            return "col-lg-" + colSize;
        }
        return "d-none";
    };
    QuestionComponent.prototype.notifyAnswered = function () {
        this.answered.emit(this.question);
    };
    QuestionComponent.prototype.getQuestionTextClasses = function () {
        //ng-class="{'col-md-6': horizontal, 'col-xs-12': vertical}" 
        if (this.horizontal) {
            return 'col-lg-' + this.question_class_size;
        }
        else {
            return 'col-12';
        }
    };
    QuestionComponent.prototype.calculateColumnSizes = function () {
        if (this.labels && this.labels.length > 6) {
            // keep a minimum of 2 rows for the question.
            this.question_class_size = Math.max(2, 12 - this.labels.length);
        }
        else {
            this.question_class_size = this.LABEL_SIZE;
        }
    };
    return QuestionComponent;
}());
export { QuestionComponent };



// WEBPACK FOOTER //
// ./src/app/assessments/question/question.component.ts.pre-build-optimizer.js